import React from "react";
import ConversationAvatar from "./ConversationAvatar";

interface Props {
	avatars: string[];
}

interface AmountProps {
	amount: number;
}

const AvatarMore = ({ amount }: AmountProps) => {
	const styles = {
		background: "#DCE6F5",
		color: "#0085E9",
	};
	return (
		<div className="intercom-avatar d-flex align-items-center justify-content-center" style={styles}>
			+{amount}
		</div>
	);
};

const ConversationAvatars = ({ avatars }: Props) => {
	const filteredAvatars = avatars.filter((av, index) => index < 5);
	return (
		<>
			{filteredAvatars.map((avatar) => {
				return <ConversationAvatar avatar={avatar} key={avatar} />;
			})}
			{avatars.length > filteredAvatars.length && <AvatarMore amount={avatars.length - filteredAvatars.length} />}
		</>
	);
};
export default ConversationAvatars;
